<template>
  <div class="action-tray">
    <component v-for="(action, index) in storeActions" :is="action.component" v-bind="action.props" :key="index"/>
  </div>
</template>

<script>
import Mixin from './ActionsTray.js'

export default {
  name: 'action-tray',
  mixins: [Mixin],
  data () {
    return {
      active: null
    }
  }
}
</script>

<style type="scss">
  .action-tray .icon {
    color:#505050 !important;
  }
  .action-tray {
    margin-right: 2px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-end;
    height: 100%;
  }
  .action-tray .btn.btn--large {
    min-width: 100px;
  }
</style>



// WEBPACK FOOTER //
// src/components/actions-tray/ActionsTray.vue